<template>
  <div class="forward-sales-guide">
    <button
      type="button"
      class="btn btn-link p-0 d-inline-flex align-items-center gap-2 text-decoration-none"
      :aria-expanded="guideOpen"
      :aria-controls="guideBodyId"
      @click="guideOpen = !guideOpen"
    >
      <FontAwesomeIcon icon="fa-regular fa-circle-info" />
      <span class="fw-semibold">{{ $t("forwards.mandates.guide.title") }}</span>
      <FontAwesomeIcon :icon="guideOpen ? 'chevron-down' : 'chevron-right'" />
    </button>
    <div v-show="guideOpen" :id="guideBodyId" class="mt-2">
      <h6 class="mb-1">{{ $t("forwards.mandates.intro.title") }}</h6>
      <ForwardSalesIntroComponent :country />
    </div>
  </div>
</template>

<script setup lang="ts">
import ForwardSalesIntroComponent from "@/forwards2/components/ForwardSalesIntroComponent.vue";
import { ref, useId } from "vue";

/**
 * A collapsible guide to forward sales: the introduction and its materials
 * (`ForwardSalesIntroComponent`). The dashboard's mandates panel shows it below the timeline of an
 * account that has mandates — one without mandates gets the introduction, open, in the panel's call to
 * create a first mandate — and the new mandate wizard at the start of its first step. How to group a
 * mandate's devices sits below the editor's deal eligibility (`MandateEligibilityGuideComponent`).
 * `country` picks the materials' language versions; null leaves it to the interface language.
 */
withDefaults(
  defineProps<{
    country?: string | null;
  }>(),
  { country: null }
);

const guideBodyId = useId();

// Collapsed on every mount, never remembered (user decision, 2026-10-13).
const guideOpen = ref(false);
</script>
